import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import TeamsListPage from '../components/TeamsListPage'
import {
  actionCreators,
  ITeamsListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/teamsList'

export default connect(
  createStructuredSelector<ApplicationState, ITeamsListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(TeamsListPage)
